<template>
  <md-content class="right-detail md-elevation-12" v-if="true">
    <div @click="$emit('close')" class="right-detail-close"><md-icon>close</md-icon></div>
    <div style="margin:0 36px;text-align:left">
      <h1>{{ selectedArtist.Name }}</h1>
      <p>{{ selectedArtist.Bio }}</p>
    </div>
    <div class="website" v-if="selectedArtist.website.trim().length"><a :href="selectedArtist.website" target="_blank">{{ selectedArtist.website }}</a></div>
    <div class="socials">
      <span class="link" v-if="selectedArtist.instagram.trim().length"><a :href="selectedArtist.instagram" target="_blank"><img src="../assets/instagram.png" alt=""></a></span>
      <span class="link" v-if="selectedArtist.facebook.trim().length"><a :href="selectedArtist.facebook" target="_blank"><img src="../assets/facebook.png" alt=""></a></span>
      <span class="link" v-if="selectedArtist.twitter.trim().length"><a :href="selectedArtist.twitter" target="_blank"><img src="../assets/twitter.png" alt=""></a></span>
      <span class="link" v-if="selectedArtist.soundcloud.trim().length"><a :href="selectedArtist.soundcloud" target="_blank"><img src="../assets/soundcloud.png" alt=""></a></span>
    </div>
  </md-content>
</template>

<script>
export default {
  props: {
    selectedArtist: Object
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Amatic SC";
  src: url("../assets/AmaticSC-Bold.otf");
}
h1 {
  font-family: 'Amatic SC', cursive;
}
@media (min-width: 900px) {
  .right-detail {
    position: absolute;
    z-index: 1;
    right: 0px;
    width: 560px;
    height: 100%;
    overflow: auto;
  }
}

@media (min-width: 600px) {
  .right-detail {
    position: absolute;
    z-index: 1;
    right: 0px;
    width: 400px;
    height: 100%;
    overflow: auto;
  }
}

@media (max-width: 600px) {
  .right-detail {
    position: absolute;
    z-index: 1;
    right: 0px;
    width: 100%;
    height: 100%;
    overflow: auto;
  }
}
.md-card {
  margin: 40px;
  display: inline-block;
  vertical-align: top;
}
.right-detail-close {
  font-size:24px;
  margin:10px;
  text-align: right
}
.right-detail-close span:hover {
  cursor: pointer;
}
.website {
  text-align: left;
  margin: 36px;
}
.socials {
  text-align: left;
  margin: 0 24px;
  .link {
    margin: 12px
  }
}

</style>
